import { Country } from "@core/schema/Country.js";

export function calculateDeliveryETA(orderDate: Date, country: Country | "outsideEu" | null): Date | null {
	if (country !== Country.Czechia) {
		return null;
	}

	const deliveryDate = new Date(orderDate);
	deliveryDate.setDate(deliveryDate.getDate() + 2);

	const deliveryDay = deliveryDate.getDay();

	// If deliveryTime is on weekend -> next Tuesday
	if (deliveryDay === 0 || deliveryDay === 6) {
		const daysUntilTuesday = (9 - deliveryDate.getDay()) % 7;
		deliveryDate.setDate(deliveryDate.getDate() + daysUntilTuesday);
	}

	return deliveryDate;
}
